var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.468a1 1 0 0 1 .36-.768l5-4.167a1 1 0 0 1 1.28 0l5 4.167a1 1 0 0 1 .36.768V13.4a.6.6 0 0 1-.6.6H9.6a.6.6 0 0 1-.6-.6v-2.8a.6.6 0 0 0-.6-.6h-.8a.6.6 0 0 0-.6.6v2.8a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6z"
})));
export default SvgIcHome;